export default "__VITE_ASSET__rwPc5HQ0__"